// Copyright ©️ 2026 eVolve MEP, LLC

/**
 * Returns true if `key` is a key of `obj`
 * *and* `obj[key]` is not nil.
 */
export const isKeyOf = <T extends object>(
  key: keyof T | string | number | symbol | undefined,
  obj: T,
): key is keyof T =>
  !!key &&
  key in obj &&
  /** We check against `undefined` here so that if an object contains a key and the value
   *  is `null`, we'll still return `true` */
  obj[key as keyof T] !== undefined;
